import { i18n } from "translate/i18n";

export const read = i18n.t("messages.bibleReading.read");
